export default __webpack_public_path__ + "static/media/milestone 2600.125371e3.svg";